// extracted by mini-css-extract-plugin
export const header = "header-module--header--2K2b3";
export const logo = "header-module--logo--3tWQ2";
export const list = "header-module--list--1iGZu";
export const listItem = "header-module--listItem--2Y_r-";